module.exports = __webpack_public_path__ + "static/mile-high-boys-club3.9ce32438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mile-high-boys-club3.png
// module id = 1701
// module chunks = 173894859265406